import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import type { StartupItem } from "../../types/startupItem";
import ItemCard from "./ItemCard";

import "./SelectStartupItem.scss";

const NoResultsView = () => (
  <Typography.Text className="select-startup-item">
    <FormattedMessage id="noResults" />
  </Typography.Text>
);

type Props = {
  startupItemList: StartupItem[];
  handleSelect: (id: string | number) => void;
  searchText: string;
  setSearchText: (value: string) => void;
};

const SelectStartupItem = ({ startupItemList, handleSelect, searchText, setSearchText }: Props) => (
  <div className="select-startup-item-wrapper">
    <SearchFilter
      searchValue={searchText}
      doSearch={setSearchText}
      placeholderIntlKey="search.two.letters"
      className="select-startup-item-search-filter"
    />
    <div className="select-startup-item-results">
      {startupItemList.length === 0 ? (
        <NoResultsView />
      ) : (
        startupItemList.map((item) => (
          <ItemCard key={item.id} handleSelect={() => handleSelect(item.id)} title={item.title} subtitle={item.subtitle} />
        ))
      )}
    </div>
  </div>
);

export default SelectStartupItem;
